import React from "react";
import {
  LayoutDashboard,
  Users,
  GitBranch,
  BookOpen,
  FileJson,
} from "lucide-react";

// Updated to accept props for navigation control
const SidebarNav = ({ activeView, onNavigate }) => {
  // Added 'id' to match the cases in App.js
  const navItems = [
    { id: "overview", label: "Resource Center", icon: LayoutDashboard },
    { id: "segmentation", label: "Segmentation Logic", icon: Users },
    { id: "streams", label: "Stream Frameworks", icon: GitBranch },
    { id: "blueprints", label: "Best Practice Blueprints", icon: BookOpen },
    { id: "export", label: "Export Strategy", icon: FileJson },
  ];

  return (
    <div className="h-full py-6 px-4 flex flex-col justify-between">
      <div>
        <div className="px-2 mb-8">
          {/* Rebranded Title */}
          <h2 className="text-xl font-bold tracking-tight text-white">
            Nurture<span className="text-emerald-400">Labs</span>
          </h2>
          <p className="text-xs text-slate-400 mt-1">
            Strategy & Optimization Hub
          </p>
        </div>

        <nav className="space-y-1">
          {navItems.map((item) => {
            // Determine active state dynamically based on prop
            const isActive = activeView === item.id;

            return (
              <button
                key={item.id}
                onClick={() => onNavigate(item.id)} // This triggers the view switch
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-emerald-600 text-white shadow-lg shadow-emerald-900/50"
                    : "text-slate-400 hover:text-white hover:bg-slate-800"
                }`}
              >
                <item.icon size={18} />
                {item.label}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Changed "Integration Health" to a "Status" that implies strategic readiness */}
      <div className="px-3 py-4 bg-slate-800 rounded-xl">
        <p className="text-xs text-slate-400 mb-2">Optimization Window</p>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
          <span className="text-xs font-mono text-emerald-400">ACTIVE</span>
        </div>
      </div>
    </div>
  );
};

export default SidebarNav;
